<template>
  <div :class="pageBG">
    <router-view name="header" :path="path"></router-view>
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'AppBody',
  data() {
    return {
      pageBG: "main-page-bg",
      path: "/"
    }
  },
  watch: {
    $route (to, from) {
      console.log(to.path);
      this.setBgImage(to.path);
    }
  },
  methods: {
    setBgImage: function(path) {
      console.log(path);
      this.path = path;
      switch (path) {
        case "/":
            this.pageBG = "main-page-bg";
          break;
        case "/parkingConfirmation":
            this.pageBG = "light-blue-bg";
          break;
        default:
          this.pageBG = "dark-blue-bg";
      }
    }
  },
  beforeMount() {
    this.setBgImage(this.$route.path);
  },
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  #appBody{
    /* height:80%!important; */
    /* height: 65vh; */
    /* background-color: #b8d4ff; */
    /* background-image: url("../../assets/App Background_1.jpg"); */
  }
</style>
